<template>
    <div class="container">
        <div class="row row-eq-height news-list" v-if="articles.length > 0">
            <div class="col col-3" v-for="article in articles" :key="article.id">
                <router-link :to="{name: 'Advice', params: { id: article.id }}" class="news-list__item">
                    <img v-auth-image="'/photos/'+ article.thumbnail_image_id + '?thumbnail=300'" alt="">
                    <p>{{ article.created_at }}</p>
                    <h4>{{ article.title }}</h4>
                </router-link>
            </div>
        </div>
        <div class="row profile profile--mb" v-if="articles.length == 0">
            <div class="col col-12">
                <p>Strona w budowie</p>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'AdvicesComponent',
  data () {
    return {
      articles: []
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
    method: 'get',
    url: '/lawAdvices'
    })
    .then(response => {
      next(vm => {
          vm.articles = response.data.data.articles
      })
    })
    .catch(error => next(false))
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/advices/AdvicesComponent.vue